import React from 'react';

interface IconProps {
  color?: string;
}

function Icon({ color = '#24B400' }: IconProps): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill={color}
        d="M12.28 8.072A2.09 2.09 0 0 0 9.95 9.441a.698.698 0 0 1-1.316-.463 3.488 3.488 0 0 1 6.779 1.162c0 1.3-.966 2.18-1.706 2.673-.391.26-.777.453-1.063.58l-.022.01v1.388a.698.698 0 0 1-1.395 0v-1.86c0-.3.192-.567.476-.662l.222.661-.222-.661.003-.001.016-.006a4 4 0 0 0 .355-.144c.238-.105.55-.262.856-.466.656-.437 1.085-.953 1.085-1.512a2.096 2.096 0 0 0-1.74-2.068M12 16.884a.698.698 0 0 0 0 1.395h.01a.698.698 0 0 0 0-1.395z"
      ></path>
      <path
        fill={color}
        fillRule="evenodd"
        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8.605a8.605 8.605 0 1 0 0 17.21 8.605 8.605 0 0 0 0-17.21"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default Icon;
